import { Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";

import { SubHeader } from "../../utils/componentes-utiles/SubHeader";
import { getOpcionesAdmin } from "../../services/apis";
import { OpcionesMenuNav } from "../../utils/componentes-utiles/OpcionesMenuNav";

export const Admin = () => {
	const [opciones, setOpciones] = useState([]);

	const opcionesVisibles = useMemo(() => {
		const currentOptions = Array.isArray(opciones) ? [...opciones] : [];
		

	

		return currentOptions;
	}, [opciones]);

	const cargarOpciones = async () => {
		try {
			const response = await getOpcionesAdmin();
			setOpciones(Array.isArray(response?.data) ? response.data : []);
		} catch (error) {
			console.error("Error al cargar las opciones de administracion:", error);
			setOpciones([]);
		}
	};

	useEffect(() => {
		cargarOpciones();
	}, []);

	return (
		<Grid
			container
			direction="row"
			justifyContent="center"
			alignItems="center"
			size={{ xs: 12 }}
		>
			<Grid
				container
				direction="column"
				justifyContent="start"
				alignItems="center"
				size={{ xs: 12 }}
				spacing={2}
				sx={{ minHeight: "65vh" }}
			>
				<SubHeader titulo={"Configuración"}></SubHeader>
				<OpcionesMenuNav opciones={opcionesVisibles}></OpcionesMenuNav>

				
			</Grid>
		</Grid>
	);
};
